import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import Buefy from 'buefy'
import '@mdi/font/css/materialdesignicons.min.css'
import Components from './components/'
import i18n from './i18n/'
import axios from 'axios'
import VueAxios from 'vue-axios'
import CommonUtil from './components/Utils/CommonUtil'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(Buefy, {
  defaultIconPack: 'mdi'
})
Vue.use(Components)
Vue.use(VueAxios, axios)

Vue.mixin({
  created () {
    Object.defineProperty(this, '$dialog', {
      value: this.$buefy.dialog
    })
    Object.defineProperty(this, '$toast', {
      value: this.$buefy.toast
    })
  }
})

let commonUtil = {
  // Common Util add
  install: function (Vue) {
    Vue.prototype.$commonUtil = CommonUtil
  }
}
Vue.use(commonUtil)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
